// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMaximize2 as RawLucideMaximize2 } from "lucide-react";
export const LucideMaximize2 = /* @__PURE__ */ createIcon(RawLucideMaximize2, "LucideMaximize2", 2);
